export default __webpack_public_path__ + "static/icon-home-arrow-orange-f9228b96507c0cc2e66013c01cc48a29.png";